import axios from 'axios'
import store from '@/store'
import config from '@/config/config'

export default () => {
  return axios.create({
    baseURL: `${config.apiSchema}://${config.apiHost}:${config.apiPort}/${config.apiPath}`,
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
}